export const STAKING_DURATION_1_DAY = '1D';
export const STAKING_DURATION_FIXED = 'Fixed';

export const MINING_MULTIPLIER = 4;

export const STAKING_LIMIT = 350;

//15.03.2022
export const PRE_LAUNCH_FINISH_TIMESTAMP = 1647302400 * 1000;
